import { render, staticRenderFns } from "./SystemInfoDialog.vue?vue&type=template&id=396c99aa&scoped=true"
import script from "./SystemInfoDialog.vue?vue&type=script&lang=js"
export * from "./SystemInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./SystemInfoDialog.vue?vue&type=style&index=0&id=396c99aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c99aa",
  null
  
)

export default component.exports